import React, {Component} from 'react';
import './insert.sass';
import FirebaseContext from "../../Firebase/context";
import {IMG_URL} from "../../../config/config";
import Loader from "../../commons/Loader/loader";
import Modal from "../../../components/commons/Modal/index";


class Insert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            categories: [],
            product: {
                index: 0,
                name: "", description: "",
                imgURL: IMG_URL,
                pdfName: "", isNow: false, pdfUrl: "", subCategoryId: ""
            },
            modal: {
                showModal: false,
                title: '',
                body: '',
                showButtons: false
            },
            fileName: ''
        };

        this.setRef = ref => {
            this.file = ref;
        }

    }

    componentDidMount() {
        this.getCategories();
        this.getProductLenght();
    }

    getProductLenght() {
        this.props.props.firebase.db.collection("products").get().then((product) => {
            if(product.docs){
                this.setState((prevState) => ({
                    ...prevState,
                    product: {...prevState.product, index: product.docs.length + 1}
                }))
            }
        }).catch(error => {
            this.showModal('ERROR', 'Si è verificato un errore. Riprova più tardi!', false);
            console.log(error)
        });
    }

    //apertura modale
    showModal = (title, body) => {
        this.setState((prevState) => ({
            ...prevState, modal: {
                ...prevState.modal,
                showModal: true, title: title, body: body
            }
        }));
    }

    //chiusura modale
    closeModal = () => {
        this.setState((prevState) => ({...prevState, modal: {...prevState.modal, showModal: false}}));

    }


    getCategories() {
        let categories = []
        this.setState({loading: true});
        this.props.props.firebase.db.collection("categories").get().then((category) => {
            category.forEach((doc) => {
                categories.push(doc.data());
            });
            this.deferSubCat(categories);
        }).catch(error => {
            this.showModal('ERROR', 'Si è verificato un errore. Riprova più tardi!');
            console.log(error)
        });
    }

    deferSubCat(categories) {
        categories.map(async (item) => {
            if (item.subCategories.length > 0) {
                item.subCategories.map((it, key) => {
                    return it.get().then((sub) => {
                        item.subCategories[key] = sub.data();
                        if (sub.id) {
                            item.subCategories[key].id = sub.id;
                        } else {
                            item.subCategories[key].id = "";
                        }
                        if (this.state.product.subCategoryId === '') {
                            this.setState((prevState) => ({
                                ...prevState,
                                product: {...prevState.product, subCategoryId: sub.id}
                            }))
                        }
                    });
                })
            }
        });
        setTimeout(function () {
            this.setState({categories: categories, loading: false});
        }.bind(this), 1000)
    }

    selectCategory(event) {
        let value = event.target.value;
        this.setState((prevState) => ({...prevState, product: {...prevState.product, subCategoryId: value}}));
    }

    productChange(e) {
        const {name, value} = e.target;
        this.setState((prevState) => ({...prevState, product: {...prevState.product, [name]: value}}));
    }

    clickSubmit(e) {
        e.preventDefault();
        this.setState({loading: true});
        if (this.file.files.length > 0) {
            const file = this.file.files[0];
            const storeageRef = this.props.props.firebase.sto.ref("products");
            const mainImage = storeageRef.child(file.name);
            mainImage.getDownloadURL().then(url => {
                this.setState({loading: false});
                this.showModal('Attenzione', 'Il nome del pdf è già esistente! Ti preghiamo di modificare il nome del file e riprovare. Grazie!');
            }).catch(error => {
                mainImage.put(file).then((result) => {
                mainImage.getDownloadURL().then((url) => {
                    this.setState((prevState) => ({
                        ...prevState,
                        product: {...prevState.product, pdfName: file.name, pdfUrl: url}
                    }));
                    this.updateSubmit(e);
                }).catch(error => {
                    console.log("pdf " + error)
                    this.showModal('ERROR', 'Si è verificato un errore. Riprova più tardi!');
                })
            })
            });

        } else {
            this.updateSubmit(e);
        }

    }

    updateSubmit(e) {
        const {product} = this.state;
        if (product.name.trim() !== '' || product.description.trim() !== '') {
            this.props.props.firebase.db.collection("products").add(product).then(result => {
                this.file.value = '';
                this.setState({loading: false, fileName: ''});
                this.setState((prevState) => ({
                    ...prevState, product: {
                        ...prevState.product,
                        name: "", description: "", pdfName: "", isNow: true, pdfUrl: "",
                    }
                }));
                this.showModal('Success', 'Operazione avvenuta con successo!');
                console.log("add " + result)
            }).catch(error => {
                this.setState({loading: false});
                this.showModal('ERROR', 'Si è verificato un errore. Riprova più tardi!');
                console.log("add " + error)
            });
        }
    }

    changePdf(e) {
        if (this.file.files.length > 0) {
            this.setState({fileName: this.file.files[0].name});
        }
    }

    render() {
        const {state} = this.props;
        const product = this.state.product;
        const category = (this.state && this.state.categories && this.state.categories.length > 0) ? this.state.categories.map((item, i) => {
            return <optgroup label={item.name} key={item.name.toString()} value={i}>
                {item.subCategories.map((cat) =>
                    <option key={cat.name.toString()} value={cat.id.toString()}>
                        {cat.name}
                    </option>
                )}
            </optgroup>
        }) : null;

        return (
            <div>
                <div className="insert">
                    <label className="title_product">Inserisci Prodotti</label>
                    <div className="disp_row">
                        <div className="disp_col down_disp_row">
                            <h3 className="title">Scegli Categoria</h3>
                            <select className="chooseCategory"
                                    onChange={this.selectCategory.bind(this)}>
                                {category}
                            </select>
                        </div>

                        <div className='form_input down_disp_row'>
                            <label className="title">Nome</label>
                            <input type="text" name="name" value={product.name} placeholder="Nome"
                                   onChange={this.productChange.bind(this)}/>
                            {product.name.trim() === '' &&
                            <div className="help_block">Il nome è obbligatorio</div>
                            }
                        </div>


                    </div>

                    <div className="disp_row_inv">
                        <div className="down_disp_row">
                            <label className="title">Carica il PDF</label>
                            <div className="upload-btn-wrapper">
                                <div className="row_upload">
                                    <button className="btn_upload">Seleziona</button>
                                    <label className="text_pdf">{this.state.fileName}</label>
                                </div>
                                <input className="pdf" type="file" name="myfile" onChange={this.changePdf.bind(this)}
                                       ref={this.setRef} accept=".pdf"/>
                            </div>

                            {/*<input className="pdf" type="file"  ref={this.setRef} accept=".pdf"/>*/}
                        </div>

                        <div className="form_input down_disp_row">
                            <label className="title">Descrizione</label>
                            <textarea className="description" type="text" placeholder="Descrizione" name="description"
                                      value={product.description}
                                      onChange={this.productChange.bind(this)}/>
                        </div>


                    </div>

                    <div className="disp_row flex_end">
                        <button className="button_login"
                                disabled={product.name.trim() === ''}
                                onClick={this.clickSubmit.bind(this)}>Carica Prodotto
                        </button>
                    </div>
                </div>
                {this.state.modal.showModal &&
                <Modal modal={this.state.modal} closeModal={this.closeModal.bind(this)}/>}

                {this.state.loading && <Loader/>}
            </div>

        )
    }
}

Insert.contextType = FirebaseContext;

export default Insert;

